import { FC } from 'react';
import { ButtonElement } from './DropdownButtonButton.styles';

export type ButtonVariation = 'primary' | 'secondary' | 'tertiary' | 'link' | 'clean' | 'delete';

export type ButtonSize = 'small' | 'medium-small' | 'medium' | 'large';

export interface IProps {
  /** "primary" (blue) | "secondary" (white, default) | "tertiary" (pink) | "link" | "clean" */
  variation?: ButtonVariation;
  /** Called when button is clicked with the event passed in */
  onClick?: (e?: any) => void;
  /** Defaults to false.  When true, button appears "grayed out" and cannot be clicked */
  disabled?: boolean;
  /** Button type.  Defaults to "button" */
  type?: string;
  /** Button size. One of "small", "medium-small", "medium" (default) or "large" */
  size?: ButtonSize;
  /** Button ARIA label tag */
  ariaLabel?: string;
}

export const DropdownButtonButton: FC<IProps> = props => {
  return (
    <ButtonElement
      data-testid="Button"
      aria-label={props.ariaLabel ? props.ariaLabel : null}
      {...props}
      type={props.type || 'button'}
    />
  );
};
